<template>
    <div>
        <el-card>
            <div slot="header" class="calendarHeader">
                <el-button :type="isSelect?'':'primary'" @click="allScheduling">全部排班</el-button>
                <el-button :type="isSelect?'primary':''" @click="myScheduling">我的排班</el-button>
                <span class="grey"></span><span class="headerText">非本月排班</span>
                <span class="lightblue"></span><span class="headerText">本月排班</span>
            </div>
            <div class="calendarBox">
                <full-calendar :events="monthData" class="test-fc"
                        first-day='1' lang="zh"
                        @changeMonth="changeMonth"
                        @eventClick="eventClick">
                </full-calendar>
            </div>
        </el-card>
    </div>
</template>

<script>

    import services from './workforce.service.js'; 
    import { FullCalendar } from 'vue-fullcalendar';
    export default {
        data: function () {
            return {
                monthData: [],//渲染的日历数据
                sendData:{//请求日历的参数
                    queryOptions:1,
                    monthDate:'',
                },
                keepMonth:undefined,//切换月份的时候记录当前月份
                isSelect:true,//是否选中我的排班
            }
        },
        mounted(){
            this.sendData.monthDate = this.getData();
            // this.getList();
        },
        methods: {
            getData(){//获取当月第一天日期
                let date = new Date();
                let year = date.getFullYear();
                let month = (date.getMonth()+1) > 9 ? date.getMonth()+1 : '0'+(date.getMonth()+1);
                return year + '-' + month + '-01';
            },
            getList(){//获取数据
                this.monthData = [];
                services.arrangementCanlendar(this.sendData).then(res=>{
                    res.forEach(item => {
                        this.monthData.push({title:item.schedulingTitle+'('+item.dutyStaffName+')',start:item.dutyDate});
                    });
                }).catch(err => {
                    this.$message.error(err.message);
                })
            },
            // 选择月份
            changeMonth (start, end, current) {
                this.keepMonth = current;//保留切换的月份
                this.sendData.monthDate = current;
                // console.log(current);
                this.getList();
            },
            // 点击事件
            eventClick (event, jsEvent, pos) {
                // console.log(event);
                // console.log(jsEvent);
                // console.log(pos);
            },
            allScheduling(){//全部排班
                this.isSelect = false;
                this.sendData.queryOptions = 2;
                if(this.keepMonth){//判断是否切换过月份
                    this.sendData.monthDate = this.keepMonth;
                }else{
                    this.sendData.monthDate = this.getData();
                }
                this.getList();
            },
            myScheduling(){//我的排班
                this.isSelect = true;
                this.sendData.queryOptions = 1;
                if(this.keepMonth){//判断是否切换过月份
                    this.sendData.monthDate = this.keepMonth;
                }else{
                    this.sendData.monthDate = this.getData();
                }
                this.getList();
            }
        },
        components: {
            'full-calendar': require('vue-fullcalendar'),
        },
    }

</script>
<style scoped>
    .calendarHeader .headerText{
        vertical-align: middle;
        margin-left: 4px;
    }
    .calendarHeader .grey{
        display: inline-block;
        width: 40px;
        height: 14px;
        background: grey;
        vertical-align: middle;
        margin-left: 24px;
    }
    .calendarHeader .lightblue{
        display: inline-block;
        width: 40px;
        height: 14px;
        background: lightblue;
        vertical-align: middle;
        margin-left: 30px;
    }
    /deep/.full-calendar-body .dates .dates-events .events-week .events-day .event-box .event-item.is-start{
        background: lightblue !important;
    }
    /deep/.full-calendar-body .dates .dates-events .events-week .events-day .event-box .event-item.is-start:hover{
        background: yellow !important;
    }

    /*非本月的排班，让他显示灰色*/
    /deep/.full-calendar-body .dates .dates-events .events-week .not-cur-month .event-box .event-item.is-start{
        background: lightgray !important;
        /*display: none;*/
    }
    /deep/.full-calendar-body .dates .dates-events .events-week .not-cur-month .event-box .event-item.is-start:hover{
        background: lightgray !important;
        /*display: none;*/
    }
</style>
<style rel="stylesheet/scss" lang="scss" scoped>
    .A{
        background: blue;
        color: red;
    }
    .event-box{
        background: red;
    }
    .full-calendar-body .dates .dates-events .events-week .events-day .event-box{
        background: red !important;
    }
    .calendarBox{
        /deep/ .comp-full-calendar{
            max-width: 1200px !important;
        }
        /deep/ .week{
            height: 40px;
            line-height: 40px;
            font-size: 16px;
        }
        /deep/ .prev-month{
            font-size: 23px;
        }
        /deep/ .title{
            font-size: 18px;
        }
        /deep/ .next-month{
            font-size: 23px;
        }
    }
</style>
